const volcanes = {
  payingByMessage: 'Paying through ',
  safePaymentPage: 'Secure payment page',
  finishYourPaymentMessage: 'Finish your purchase, complete your payment here :)',
  inputCustomerName: 'Name',
  inputCustomerEmail: 'Email',
  inputCustomerPhoneNumber: 'Phone Number',
  inputCustumerPhoneNumberOptional: '(optional)',
  emptyCardSecurityCode: 'Fill in the card\'s security code',
  invalidSecurityCode: 'Invalid security code',
  invalidCvv: 'Invalid CVV',
  fieldCardSecurityCode: 'Security code (CVV)',
  fieldCardHolderName: 'Full name (as shown in card)',
  fieldCardExpiryDate: 'Expiration Date',
  placeholderCardExpiryDate: 'MM/YYYY',
  fieldCardNumber: 'Card number',
  fieldOneClickCardNumber: '{brand} last {lastFour}',
  transactionFeeTooltip: 'Processing Costs',
  total: 'Total',
  amount: 'Amount',
  termsLabel: 'By paying you agree to the  ',
  termsReferenceLink: 'terms of service',
  termsEbanxLabel: ' of EBANX.',
  paymentPageTitle: 'Payment Page',
  selectPaymentMethod: 'Select a payment method',
  fatalErrorTitle: 'Oops!',
  fatalErrorMessage: 'Unfortunately, we couldn\'t find your payment details.',
  fatalErrorFooter: 'Secure payment powered by',
  panamaUsdDisclaimer: 'Payments are processed via EBANX. Due to regional routing, your bank statement may reference Panama (PAB), which maintains a fixed 1:1 parity with USD. The final charge should reflect the USD price shown.',
  merchantPaymentCode: 'Order #',
};

module.exports = volcanes;
